import React from 'react';
import { Link } from 'react-router-dom';
import ReferralProgramTermsContent from 'components/ReferralProgramTermsContent';

export default function ReferralProgramTerms() {
  return (
    <div className="auth-login-page">
      <div className="container py-5 referral-program-terms-page">
        <h1 className="mb-4">Referral Program Terms</h1>
        <ReferralProgramTermsContent />
        <p className="mt-4 mb-0">
          <Link to="/settings">Back to Account &amp; Settings</Link>
        </p>
      </div>
    </div>
  );
}
